import { HttpError } from "@/browser";

export interface IFetcherState<R> {
  payload?: R;
  working: boolean;
  error?: HttpError;
  counter: number;
}

export const initialState: IFetcherState<unknown> = {
  payload: undefined,
  working: false,
  error: undefined,
  counter: 0,
};

export type ActionTypes<R> =
  | { type: "FETCH_START" }
  | { type: "FETCH_SUCCESS"; payload: R | undefined }
  | { type: "FETCH_ERROR"; error: HttpError };

export const reducer = <R>(state: IFetcherState<R>, action: ActionTypes<R>): IFetcherState<R> => {
  switch (action.type) {
    case "FETCH_START": {
      return {
        ...state,
        working: true,
        error: undefined,
      };
    }
    case "FETCH_SUCCESS": {
      const { payload } = action;
      return {
        ...state,
        working: false,
        error: undefined,
        payload,
        counter: state.counter + 1,
      };
    }
    case "FETCH_ERROR":
      return {
        ...state,
        working: false,
        error: action.error,
        counter: state.counter + 1,
      };

    default:
      return state;
  }
};
